// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__24BOE","header":"Messages_header__CKnt3"};